var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-container",attrs:{"id":"ImageCapture"}},[(_vm.activeComponent == 'recognition-with-core-values')?_c('div',[_c('chart-recognition-core-value')],1):_c('div',[_vm._v("else")])])}
var staticRenderFns = []

export { render, staticRenderFns }